import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Weekdays } from "@msuite/ui/weekday-picker";
import type { Tables } from "@msuite/utils/types";
import { RowActions } from "./row-actions";
import { TourWaveCutoffOffsetHint } from "./tour-wave-cutoff-offset-hint";

const columnHelper = createColumnHelper<Tables<"tourWaves">>();

export const columns = [
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
		size: 300,
	}),
	columnHelper.accessor("startTime", {
		id: "start-time",
		header: localized("dates.start_time"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("endTime", {
		id: "end-time",
		header: localized("dates.end_time"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("weekdays", {
		id: "weekdays",
		header: localized("dates.weekdays"),
		cell: (cell) => (
			<div className="mr-4">
				<Weekdays
					selectedDays={cell.getValue()}
					size="xs"
				/>
			</div>
		),
		size: 400,
		enableResizing: false,
	}),
	columnHelper.accessor("cutoffOffset", {
		id: "cutoff-offset",
		header: localized("stock.deadline"),
		cell: (cell) => <TourWaveCutoffOffsetHint item={cell.row.original} />,
	}),
	createRowActions(RowActions),
];
